import {flsModules} from '../modules.js';

import AirDatepicker from 'air-datepicker';

import localeEn from 'air-datepicker/locale/en.js';

function getWeekNumber(date) {
	const currentDate = typeof date === 'object' ? date : new Date();
	const januaryFirst = new Date(currentDate.getFullYear(), 0, 1);
	const daysToNextMonday = januaryFirst.getDay() === 1 ? 0 : (7 - januaryFirst.getDay() + 1) % 7;
	const nextMonday = new Date(currentDate.getFullYear(), 0, januaryFirst.getDate() + daysToNextMonday);
	
	// Проверка, если текущий месяц декабрь и неделя включает 1 января
	if (currentDate.getMonth() === 11 && // Декабрь
		currentDate.getDate() + 6 > 31 // Текущая дата + 6 выходит за пределы месяца
	) {
		return 1; // Первая неделя нового года
	}
	
	// Если неделя начинается до первого понедельника
	if (currentDate < nextMonday) {
		const previousYear = currentDate.getFullYear() - 1;
		const lastDayOfPreviousYear = new Date(previousYear, 11, 31);
		return getWeekNumber(lastDayOfPreviousYear); // Последняя неделя предыдущего года
	}
	
	// Корректный расчёт номера недели
	return Math.ceil((currentDate - nextMonday) / (24 * 3600 * 1000) / 7) + 2; // +2 из-за сдвига на следующую неделю
}

// const date = new Date(2024, 8, 30); // 15 октября 2024 года
// console.log(getWeekNumber(date)); // Например, 42

let pickers = document.querySelectorAll('[data-datepicker]');

pickers.forEach((datePicker) => {
	// Инициализация календаря
	let parentPicker = datePicker.closest('.calendar');
	const defaultDays = parseInt(datePicker.dataset.default, 10);
	let defaultDates = undefined;
	
	if (!isNaN(defaultDays) && defaultDays > 0) {
		const today = new Date();
		const end = new Date();
		end.setDate(today.getDate() + defaultDays);
		defaultDates = [today, end];
	}
	let picker = new AirDatepicker(datePicker, {
		locale: {
			...localeEn.default,
			daysMin: localeEn.default.daysShort,
			dateFormat: 'dd-MM-yyyy',
		},
		selectedDates: defaultDates,
		firstDay: 1,
		range: true,
		container: parentPicker, // inline: true,
		autoClose: false,
		showOtherMonths: false,
		selectOtherMonths: false,
		position: 'bottom center',
		multipleDatesSeparator: ' — ',
		navTitles: {
			days: 'MMMM yyyy',
		},
		buttons: [{
			content: 'Confirm date(s)', // Текст кнопки
			className: 'button button--green button--rounded', // Указанные классы
			onClick: (dp) => {
				dp.hide(); // Скрытие календаря
			},
		}, // Стандартная кнопка "Очистить"
		],
		prevHtml: `
	<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 12 12">
		<path fill-rule="evenodd" d="M8.53 10.53a.75.75 0 0 0 0-1.06L5.06 6l3.47-3.47a.75.75 0 0 0-1.06-1.06l-4 4a.75.75 0 0 0 0 1.06l4 4a.75.75 0 0 0 1.06 0Z" clip-rule="evenodd"/>
	</svg>
`,
		nextHtml: `
	<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 12 12">
		<path fill-rule="evenodd" d="M3.47 10.53a.75.75 0 0 1 0-1.06L6.94 6 3.47 2.53a.75.75 0 0 1 1.06-1.06l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06 0Z" clip-rule="evenodd"/>
	</svg>
`,
		onRenderCell({
			cellType,
			date
		}) {
			// Добавляем номер недели в первую ячейку недели
			if (cellType === 'day' && date.getDay() === 1) {
				return {
					html: `<span class="week-number">${getWeekNumber(date)}</span><span class="custom-day">${date.getDate()}</span>`,
				};
			}
		},
	});
	flsModules.datepicker = picker;
});